import { parseCalendarDate } from "../../lib/format.js";
//#region src/components/_dateField/typed.ts
var US_DATE = /^(\d{1,2})\/(\d{1,2})\/(\d{4})$/;
var ISO_DATE = /^(\d{4})-(\d{1,2})-(\d{1,2})$/;
/** A date in either form, anywhere in the text (a range has two). */
var ANY_DATE = /\d{1,2}\/\d{1,2}\/\d{4}|\d{4}-\d{1,2}-\d{1,2}/g;
/** What may sit between a range's dates: spaces, a dash or "to". */
var RANGE_SEPARATOR = /^\s*(?:[-–—]|to)?\s*$/i;
/**
* A typed day as a local-midnight Date (Calendar's), or null when the text isn't a real
* day in either form: "2/30/2026" and "13/01/2026" are null.
*/
function parseTypedDate(text) {
	const trimmed = text.trim();
	const us = US_DATE.exec(trimmed);
	const iso = us ? null : ISO_DATE.exec(trimmed);
	const parts = us ? {
		year: Number(us[3]),
		month: Number(us[1]),
		day: Number(us[2])
	} : iso ? {
		year: Number(iso[1]),
		month: Number(iso[2]),
		day: Number(iso[3])
	} : null;
	const day = parts && parseCalendarDate(parts);
	return day ? new Date(day.year, day.month - 1, day.day) : null;
}
/**
* A typed range: `{ start, end }` (in order; `end` null for one date), an empty range for
* blank text, or null when it isn't one or two real days joined by a dash or "to".
*/
function parseTypedRange(text) {
	if (text.trim() === "") return {
		start: null,
		end: null
	};
	const found = text.match(ANY_DATE) ?? [];
	if (found.length === 0 || found.length > 2) return null;
	const [first, second] = found.map(parseTypedDate);
	if (!first || found.length === 2 && !second) return null;
	const [before, between = "", after = ""] = text.split(ANY_DATE);
	if (before.trim() || after.trim() || !RANGE_SEPARATOR.test(between)) return null;
	if (!second) return {
		start: first,
		end: null
	};
	return first.getTime() <= second.getTime() ? {
		start: first,
		end: second
	} : {
		start: second,
		end: first
	};
}
//#endregion
export { parseTypedDate, parseTypedRange };

//# sourceMappingURL=typed.js.map